import { Close } from '@mui/icons-material'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React from 'react'
import { StripeConnectButton } from '../Adopters/StripeConnectButton'
import { MemberAccessReminderLevel } from '../../utils/hooks/useMemberAccessPolicy'

interface Props {
  isOpen: boolean
  onClose: () => void
  daysRemaining: number | null
  reminderLevel: MemberAccessReminderLevel | null
}

const getReminderTitle = (reminderLevel: MemberAccessReminderLevel | null) => {
  if (reminderLevel === 'expired') {
    return 'Votre période d’essai illimitée est terminée'
  }

  return 'Conservez vos licences illimitées gratuitement'
}

export const StripeConnectRetentionModal: React.FC<Props> = ({ isOpen, onClose, daysRemaining, reminderLevel }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ position: 'relative', pr: 6 }}>
        <Typography variant="h6" fontWeight={800}>
          {getReminderTitle(reminderLevel)}
        </Typography>
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography>
            Activez Stripe Connect pour conserver un nombre illimité d&apos;utilisateurs, même après les 3 mois.
          </Typography>
          {daysRemaining != null && reminderLevel !== 'expired' && (
            <Typography fontWeight={700}>Il vous reste {Math.max(daysRemaining, 0)} jour(s) avant la fin.</Typography>
          )}
          <Typography variant="body2" color="text.secondary">
            Stripe Connect est notre levier principal pour financer Petso sans vous facturer ces licences.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, justifyContent: 'space-between' }}>
        <Typography
          onClick={onClose}
          sx={{ cursor: 'pointer', color: 'text.secondary', textDecoration: 'underline', fontSize: 14 }}
        >
          Plus tard
        </Typography>
        <StripeConnectButton
          variant="contained"
          color="primary"
          fullWidth={false}
          content="Configurer Stripe Connect"
          sx={{ textTransform: 'none', fontWeight: 700 }}
        />
      </DialogActions>
    </Dialog>
  )
}
